// extracted by mini-css-extract-plugin
export default {"QRCodeModal":"QrCodeModal_QRCodeModal__U8Zh5"};